(() => {
  "use strict";

  const formatImageUrl = (url, width = 500) => {
    if (!url) return "";
    if (url.includes("width=")) {
      return url.replace(/width=\d+/, `width=${width}`);
    }
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}width=${width}`;
  };

  window.formatImageUrl = formatImageUrl;

  const searchSuggestionsComponent = (config = {}) => {
    return {
      formatImageUrl,
      redirects: config.redirects || [],
      url: new URL(window.location.href),
      searchFormIsOpen: false,
      searchInput: null,
      searchResults: [],
      searchSuggestions: [],
      suggestedCollections: [],
      suggestedPages: [],
      resultsCount: 0,
      currentSearchQuery: "",
      searchInputValue: "",
      searchForm: null,

      init() {
        this.searchInput = document.querySelector("#search_input");
        this.searchForm = document.querySelector(".js-search-form__container form");
        
        if (this.searchInput) {
          this.searchInput.addEventListener(
            "input",
            this.debounce((event) => {
              this.onChange(event);
            }, 300).bind(this)
          );
        }

        window.addEventListener("open-search", () => {
          this.searchFormIsOpen = true;
          this.showMegaMenu = false;
          setTimeout(() => {
            if (this.searchInput) {
              this.searchInput.focus();
            }
          }, 50);
          this.preventBodyScroll();
        });

        window.addEventListener("close-search", () => {
          this.searchFormIsOpen = false;
          this.allowBodyScroll();
          this.resetSearchForm();
        });

        if (this.searchInputValue) {
          this.getSearchResults(this.searchInputValue);
        }
      },

      resetSearchForm() {
        if (this.searchForm) {
          this.searchForm.reset();
        }
        this.searchInputValue = "";
        this.searchResults = [];
        this.searchSuggestions = [];
        this.suggestedCollections = [];
        this.suggestedPages = [];
        this.resultsCount = 0;
      },

      onChange() {
        const query = this.searchInput ? this.searchInput.value : "";
        if (!query.length) {
          this.searchResults = [];
          this.searchSuggestions = [];
          this.suggestedCollections = [];
          this.suggestedPages = [];
          this.resultsCount = 0;
          this.searchInputValue = "";
          this.currentSearchQuery = "";
          this.url.searchParams.delete("q");
          history.replaceState({}, null, window.location.origin + window.location.pathname);
          return;
        }

        this.searchInputValue = query;
        this.currentSearchQuery = `/search?q=${encodeURIComponent(query + " -monogramming")}&type=product`;
        this.url.searchParams.set("q", query);
        history.replaceState(null, null, `?q=${encodeURIComponent(query)}&type=product`);
        this.getSearchResults(query);
      },

      getSearchResults(query) {
        const searchQuery = query + " -monogramming";
        const url = `/search/suggest.json?q=${encodeURIComponent(searchQuery)}` +
                    `&resources[type]=product,query,collection,page` +
                    `&resources[options][unavailable_products]=hide` +
                    `&resources[options][fields]=title,variants.title,product_type` +
                    `&resources[limit]=8`;

        fetch(url)
          .then((res) => {
            if (!res.ok) throw new Error("Search suggestions request failed");
            return res.json();
          })
          .then((data) => {
            const results = data.resources.results;
            const products = results.products || [];
            products.forEach((product) => {
              if (product.featured_image && product.featured_image.url) {
                product.featured_image.url = formatImageUrl(product.featured_image.url, 500);
              }
            });
            this.searchResults = products;
            this.searchSuggestions = results.queries || [];
            
            let collections = results.collections || [];
            let pages = results.pages || [];

            // Process search term redirects/recommendations
            if (this.redirects && this.redirects.length > 0 && query) {
              const q = query.toLowerCase().trim();
              this.redirects.forEach((rule) => {
                const term = rule.term.toLowerCase().trim();
                // Match condition: exact match, query contains term, or term starts with query (if query is at least 3 chars)
                const isMatch = q === term || q.includes(term) || (q.length >= 3 && term.startsWith(q));
                
                if (isMatch) {
                  if (rule.type === 'page') {
                    // Avoid duplicates
                    if (!pages.some(p => p.url === rule.url)) {
                      pages.unshift({
                        title: rule.title,
                        url: rule.url
                      });
                    }
                  } else if (rule.type === 'collection') {
                    // Avoid duplicates
                    if (!collections.some(c => c.url === rule.url)) {
                      collections.unshift({
                        title: rule.title,
                        url: rule.url
                      });
                    }
                  }
                }
              });
            }

            this.suggestedCollections = collections;
            this.suggestedPages = pages;
            
            this.resultsCount = this.searchResults.length +
                                 this.searchSuggestions.length +
                                 this.suggestedCollections.length +
                                 this.suggestedPages.length;
          })
          .catch((err) => {
            console.error("Predictive search error:", err);
          });
      },

      debounce(fn, delay) {
        let timer;
        const context = this;
        return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(context, args), delay);
        };
      },

      preventBodyScroll() {
        document.querySelector("body").style.overflow = "scroll";
        document.querySelector("html").style.overflow = "hidden";
        document.querySelector("html").style.maxHeight = "100vh";
      },

      allowBodyScroll() {
        document.querySelector("body").style.overflow = "";
        document.querySelector("html").style.overflow = "";
        document.querySelector("html").style.maxHeight = "";
      }
    };
  };

  document.addEventListener("alpine:init", () => {
    Alpine.data("searchSuggestions", searchSuggestionsComponent);
  });
})();